
import "./heroSectionStyle.css"
import React, { useContext } from "react";
import HeroSectionItem from "./heroSectionItem/heroSectionItem";
import { SelectedLanguageContext } from "../../../../contexts/siteContentsContext";

export default function HeroSection() {
    const { selectedLanguage } = useContext(SelectedLanguageContext);
    let catchPhrase = "";
    if (selectedLanguage.name ==='en-us') catchPhrase = "/photos/heroSection/catchyPhrase_EN.png";
    else if (selectedLanguage.name ==='pt-br') catchPhrase = "/photos/heroSection/catchyPhrase_PT-BR.png";

    return (
        <section className="hero-section__container">

            <div className="hero-section__wrapper">
                <HeroSectionItem catchPhrase={catchPhrase} photo={"/photos/heroSection/machine.png"} url={"/equipaments"} />
            </div>
        </section>
    );
}